// import React from 'react';
// import Lottie from 'react-lottie';
// import animationData from './Animation - 1729033356107.json';

// function Loader() {
//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: 'xMidYMid slice',
//     },
//   };

//   return (
//     <div style={loaderStyles}>
//       <Lottie options={defaultOptions} height="50%" width="50%" />
//       <h1 style={textStyles}>Loading...</h1>
//     </div>
//   );
// }
// const loaderStyles = {
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   height: '100vh',
//   backgroundColor: '#f0f0f0',
// };

// const textStyles = {
//   marginTop: '20px', // Add some spacing between the animation and the text
//   fontSize: '24px',
//   color: '#333',
// };

// export default Loader;
import React from "react";
import Lottie from "react-lottie";
import animationData from "./Animation - 1729033356107.json";

function Loader() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <div style={wrapperStyle}>
      <div style={contentStyle}>
        <Lottie options={defaultOptions} height={500} width={500} />
        <h1 style={textStyle}>Preparing your experience…</h1>
      </div>
    </div>
  );
}

export default Loader;

/* ================= STYLES ================= */

const wrapperStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "#ffffff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const contentStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  transform: "translateY(-20px)", // visual centering
};

const textStyle = {
  marginTop: "12px",
  fontSize: "30px",
  color: "#64748b",
  letterSpacing: "0.2px",
};
